import { Provider } from 'react-redux'
import { store, history } from '../redux/store'
import PublicRoutes from '../router'
import PoliciesAppHolder from './policiesAppStyle'
import Boot from '../redux/boot'
import * as Sentry from '@sentry/react'
import { QueryClientProvider,QueryClient } from '@tanstack/react-query'
import { pdfjs } from 'react-pdf'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      // every 5 minute get fresh data
      staleTime: 5 * 60 * 1000,
      // every 10 minute remove cache (gctime)
      cacheTime: 10 * 60 * 1000,
    },
    mutations: {
      retry: 0,
    }
  },
})

const PoliciesApp = () => (
  <Sentry.ErrorBoundary fallback={'An error has occurred'}>
    <PoliciesAppHolder>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <PublicRoutes history={history} />
        </QueryClientProvider>
      </Provider>
    </PoliciesAppHolder>
  </Sentry.ErrorBoundary>
)
Boot()
  .then(() => PoliciesApp())
  .catch(error => { console.error(error) })

export default PoliciesApp
